







import {
    Component,
    Vue,
    Prop,
    Watch
} from 'vue-property-decorator'
import LocoSectionWithParameters from '@/models/Graph/LocoSectionWithParameters'
import Graph from './Graph.vue'

@Component({
    components: {
        Graph
    }
})
export default class LocoSectionGraphs extends Vue {
    @Prop({
        type: Object,
        required: true
    })
    locoSectionWithParameters!: LocoSectionWithParameters
    
    get locoSectionParameters(): [] {
        const grouped = this.groupBy(this.locoSectionWithParameters.parameters as [], 'name')
        return grouped
    }

    private groupBy(array: [], key: string) {
        const started = performance.now()
        const result = {} as any
        array.forEach(item => {
            if (!result[item[key]]) {
                result[item[key]] = []
            }
            result[item[key]].push(item)
        })
        return result
    }
}
